import { render, staticRenderFns } from "./DashboardStaff.vue?vue&type=template&id=439de55a&lang=html"
import script from "./DashboardStaff.vue?vue&type=script&lang=js"
export * from "./DashboardStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports